import React, { useState } from 'react';
import Body_login from '../components/profile/login.js'

function Login() {
    return (
        <main>
            <Body_login />
        </main>

    );
}

export default Login;
